/* @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

import EnrollmentDialogCTAButton from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/EnrollmentDialogCTAButton';
import styles from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/styles';

import _t from 'i18n!nls/degree-home';

interface Props {
  enrollmentUrl: string;
}
const EnrollForCredit: React.VFC<Props> = ({ enrollmentUrl, ...styleProps }) => (
  <div {...styleProps}>
    <Typography variant="h2semibold">{_t('Enroll in your next for-credit degree course')}</Typography>
    <Typography2 component="p" css={styles.paragraphAndButtonPadding}>
      {_t(
        'Register through the university portal. The course will appear in your Coursera account once the session begins. Just fill out the form, pay tuition, and start learning!'
      )}
    </Typography2>
    <EnrollmentDialogCTAButton
      trackingName="enroll_for_credit"
      href={enrollmentUrl}
      ctaLabel={_t('Enroll for-credit')}
    />
  </div>
);

export default EnrollForCredit;
